module.exports = __webpack_public_path__ + "static/media/nucleo.9cbd9345.mp3";